import { HestiaIframeEvent, HestiaIframeTarget } from './hestiaIframeEvents'

interface HestiaIframeRelayRoute {
  event: HestiaIframeEvent
  source: HestiaIframeTarget
  target: HestiaIframeTarget
}

const ALLOWED_ROUTES: HestiaIframeRelayRoute[] = [
  {
    event: HestiaIframeEvent.WebsitePreviewReload,
    source: HestiaIframeTarget.OwnerAgentWidget,
    target: HestiaIframeTarget.WebsiteBuilder,
  },
  {
    event: HestiaIframeEvent.MenuDataInvalidate,
    source: HestiaIframeTarget.OwnerAgentWidget,
    target: HestiaIframeTarget.Loyalty,
  },
]

export const isHestiaIframeRelayRouteAllowed = ({
  event,
  source,
  target,
}: HestiaIframeRelayRoute): boolean => {
  return ALLOWED_ROUTES.some(
    (route) =>
      route.source === source &&
      route.target === target &&
      route.event === event
  )
}
